function Search() {
    return (
        <div></div>
    )
}

export default Search;